import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getStudentworkpolicy = () =>
  httpClient.get(apis.getStudentworkpolicy(), {
    ignore: true,
    ignoreLoading: true,
  });

export const getStudentworkList = (payload) => httpClient.get(apis.getStudentworkList(payload));

export const newStudentwork = (payload) => httpClient.post(apis.newStudentwork(), payload);

export const getStudentwork = (payload) => httpClient.post(apis.getStudentwork(), payload);

export const deleteStudentwork = (payload) => httpClient.post(apis.deleteStudentwork(), payload);
